const _default = theme => ({
  color: theme.tokens.ComponentLinkColor,
  textDecorationColor: theme.tokens.ComponentLinkColor,
  display: 'inline-flex',
  alignItems: 'center',
  alignContent: 'center',
  gap: '8px'
});
const _hover = theme => ({
  '&:hover': {
    color: theme.tokens.ComponentLinkHover,
    textDecorationColor: theme.tokens.ComponentLinkHover,
    svg: {
      color: theme.tokens.ComponentLinkHover,
      fill: theme.tokens.ComponentLinkHover
    }
  }
});
const _visited = theme => ({
  '&:visited': {
    color: theme.tokens.ComponentLinkVisited,
    textDecorationColor: theme.tokens.ComponentLinkVisited,
    svg: {
      color: theme.tokens.ComponentLinkVisited,
      fill: theme.tokens.ComponentLinkVisited
    }
  }
});
const _size = (theme, size) => {
  const _defaultSizeStyle = {
    fontWeight: 500,
    fontFamily: theme.tokens.ComponentLinkFontFamily,
    lineHeight: '20px'
  };
  switch (size) {
    case 'lg':
      return {
        ..._defaultSizeStyle,
        fontSize: theme.tokens.ComponentLinkFontSizeLg,
        lineHeight: '22.5px'
      };
    case 'md':
      return {
        ..._defaultSizeStyle,
        fontSize: theme.tokens.ComponentLinkFontSizeMd,
        lineHeight: '20px'
      };
    case 'sm':
      return {
        ..._defaultSizeStyle,
        fontSize: theme.tokens.ComponentLinkFontSizeSm,
        lineHeight: '18.2px'
      };
    case 'xs':
      return {
        ..._defaultSizeStyle,
        fontSize: theme.tokens.ComponentLinkFontSizeXs,
        lineHeight: '15.6px'
      };
    case 'xxs':
      return {
        ..._defaultSizeStyle,
        fontSize: theme.tokens.ComponentLinkFontSizeXxs,
        lineHeight: '13px'
      };
    default:
      return _defaultSizeStyle;
  }
};
const linkDefaultStyle = (theme, size, visitedStyle) => ({
  ..._default(theme),
  ..._hover(theme),
  ...(visitedStyle ? _visited(theme) : {}),
  ..._size(theme, size)
});
export default linkDefaultStyle;